enum TransferTypes {
  ManufacturerToInstaller = 'ManufacturerToInstaller',
  InstallerToFacilityManagement = 'InstallerToFacilityManagement',
}
export default TransferTypes;
